import {AccessControlProvider} from '@refinedev/core';

import {authProvider} from '@providers/security/auth-provider';
import {Action} from '@workspaces/access-control-types';
import {resources} from '@workspaces/resources';

export const accessControlProvider: AccessControlProvider = {
  can: async ({resource, action}) => {
    if (!resource || !action) {
      return {can: true};
    }

    const role = await authProvider.getPermissions?.();
    if (!role) {
      return {
        can: false,
        reason: 'Unauthorized',
      };
    }

    const resourcePermissions = resources.find((res) => res.name === resource)?.meta.accessControl?.[role.role];

    if (resourcePermissions && resourcePermissions.includes(action as Action)) {
      return {can: true};
    }

    return {
      can: false,
      reason: 'Unauthorized',
    };
  },
};
